import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

/**
 * /impersonate?token=<jwt> — admin-driven flow.
 * Reads the impersonation JWT from the URL, writes it to sessionStorage (tab-scoped, so the
 * admin's own localStorage token in other tabs is untouched), and redirects to /dashboard.
 */
export default function Impersonate() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [err, setErr] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setErr("Missing token"); return; }
    try {
      // Store per-tab so we don't clobber admin's session in other tabs
      sessionStorage.setItem("nb_token", token);
      // Clean the URL so the token is not left in history
      window.history.replaceState({}, document.title, "/impersonate/loading");
      // Hard reload into /dashboard so AuthProvider bootstraps fresh
      window.location.replace("/dashboard");
    } catch (e) {
      setErr(String(e?.message || e));
    }
  }, [params, nav]);

  return (
    <div className="min-h-screen bg-[#0B111C] text-slate-200 flex items-center justify-center px-4">
      <div className="nb-card p-8 max-w-md text-center">
        <ShieldAlert size={28} className="text-nb-cyan mx-auto"/>
        <div className="mt-3 font-heading text-white text-lg">Admin impersonation</div>
        <div className="text-xs text-slate-400 mt-2">
          {err ? <span className="text-red-400">{err}</span> : "Loading user account… you will be redirected to their dashboard."}
        </div>
      </div>
    </div>
  );
}
